import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function authHeaders() {
  const t = localStorage.getItem("rally_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}
